import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';
import TrackingComponent from '../components/TrackingComponent';

export default class FooterNewsletterComponent extends Component {
  get SELECTORS() {
    return {
      form: '[data-form-newsletter]',
      emailInput: '[data-email-input-newsletter]',
      hiddenBlock: '[data-newsletter-f-hidden]',
      submitButton: '[data-submit-button]',
      checkSubmitBtns: '[data-check-submit]',
      privacyCheckbox: '[data-privacy-checkbox]',
      signupMarinaCheckbox: '[data-signup-marina-checkbox]',
      signupPersonaCheckbox: '[data-signup-persona-checkbox]',
      formWrapper: '[data-js-form-wrapper]',
      formSuccess: '[data-js-form-success]',
      newsletterError: '[data-newsletter-error-msg]',
      newsletterAlready: '[data-newsletter-already-msg]'
    };
  }

  get CLASSES() {
    return {
      success: 'success',
      show: 'show',
      hidden: 'hidden',
      error: 'error'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.hiddenBlock = this.$component.querySelector(this.SELECTORS.hiddenBlock);
    this.checkSubmitBtns = this.$component.querySelectorAll(this.SELECTORS.checkSubmitBtns);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.signupMarinaCheckbox = this.$component.querySelector(this.SELECTORS.signupMarinaCheckbox);
    this.signupPersonaCheckbox = this.$component.querySelector(this.SELECTORS.signupPersonaCheckbox);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.emailInput = this.$component.querySelector(this.SELECTORS.emailInput);
    this.formWrapper = this.$component.querySelector(this.SELECTORS.formWrapper);
    this.formSuccess = this.$component.querySelector(this.SELECTORS.formSuccess);
    this.newsletterError = this.$component.querySelector(this.SELECTORS.newsletterError);
    this.newsletterAlready = this.$component.querySelector(this.SELECTORS.newsletterAlready);
    this.trackingComponent = new TrackingComponent();
  }

  listenInput() {
    this.emailInput.addEventListener('focus', () => {
      this.hiddenBlock.classList.add(this.CLASSES.show);
      this.checkSubmit();
    });
  }

  enableSubmitBtn() {
    if ( this.privacyCheckbox.checked && ( this.signupMarinaCheckbox.checked || this.signupPersonaCheckbox.checked) ) {
      this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }

  checkSubmit() {
    if (this.checkSubmitBtns != null) {
      this.checkSubmitBtns.forEach((checkbox, index) => {
        checkbox.addEventListener('click', e => {
          this.enableSubmitBtn();
        });
      });
    }
  }

  handleFormSubmit() {
    if(this.form) {
      const url = this.form.getAttribute('action');
      this.form.addEventListener("submit", (event) => {
        const form = new FormData(event.target);
        event.preventDefault();
        const response = this.NewsletterLogic.subscribeNewsletter(url, form);
        response.then(response => {
          if(response.ok) {
            this.formWrapper.classList.add(this.CLASSES.hidden);
            this.formSuccess.classList.remove(this.CLASSES.hidden);
            this.newsletterError.classList.add(this.CLASSES.hidden);
            this.newsletterAlready.classList.add(this.CLASSES.hidden);
            this.trackingComponent.trackAction('newsletterSubscribe', this.submitButton.dataset);
          } else {
            if (response.status === 400) {
              this.newsletterError.classList.remove(this.CLASSES.hidden);
              this.emailInput.classList.add(this.CLASSES.error);
            }
            if (response.status === 403) {
              this.newsletterAlready.classList.remove(this.CLASSES.hidden);
              this.emailInput.classList.add(this.CLASSES.error);
            }
            this.formWrapper.classList.remove(this.CLASSES.hidden);
            this.formSuccess.classList.add(this.CLASSES.hidden);
          }
        })
      });
    }
  }

  handleInputChange() {
    if(this.emailInput) {
      this.emailInput.addEventListener("input", event => {
        this.newsletterError?.classList.add(this.CLASSES.hidden);
        this.newsletterAlready?.classList.add(this.CLASSES.hidden);
      });
    }
  }

  bindEvents() {
    this.enableSubmitBtn();
    this.handleFormSubmit();
    this.handleInputChange();
  }

  render() {
    super.render();
    this.listenInput();
    this.NewsletterLogic = new NewsletterLogic();
    this.bindEvents();
  }
}
